import React from 'react';
import { PN_BLUE } from '../const';

const SVG = ({ style = {}, color = PN_BLUE, width = '100%', viewBox = '0 0 100 100' }) => (
  <svg style={style} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
    <g fill="none" strokeLinejoin="round">
      <g strokeWidth="18" stroke="white">
        <polyline points="37,39 37,24 64,24 64,46 50,54 50,69" />
        <polyline points="50,72 50,88" />
      </g>
      <g strokeWidth="12" stroke={color}>
        <polyline points="37,36 37,24 64,24 64,46 50,54 50,66" />
        <polyline points="50,74 50,86" />
      </g>
    </g>
  </svg>
);

export default SVG;
